const $ = require('cash-dom');
const Page = require('./page');
require('../../vendor/modernizr-custom.min');

const SmoothScroll = {
  init() {
    $('a[href^="#"]').on('click', function (e) {
      var id = $(this).attr('href');
      if (id.length > 1) {
        var $el = $(id);
        var offset = typeof $(this).attr('data-offset') !== 'undefined' && !isNaN(parseInt($(this).attr('data-offset'))) ?
          parseInt($(this).attr('data-offset')) :
          0;

        if ($el.length === 1) {
          e.preventDefault();
          Page.scrollTo(id, 0, offset);

          if (typeof Modernizr !== 'undefined' && Modernizr.history) {
            window.history.pushState(null, $('title').html(), window.location.href.replace(/#(.*)?$/, '') + id);
          }
        }
      }
    })
  },
};

module.exports = SmoothScroll;
